import secureLocalStorage from "react-secure-storage";
import React from "react";
import { GridCell } from "@progress/kendo-react-grid";
import * as moment from "moment";
import { DatePicker } from "@progress/kendo-react-dateinputs";

export default class TaskCustomFieldDate extends GridCell {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount = () => {
    try {
      let element = document.getElementsByClassName("k-dateinput")[0];
      if (element) {
        element.addEventListener("keydown", (e) => {
          e.stopPropagation();
          e.preventDefault();
        });
      }
    } catch (err) {
      console.error(err);
    }
  };
  handleBlur = (e) => {
    return;
  };
  handleChange = (e) => {
    try {
      let customFields = this.props.customFieldsData;
      let field = this.props.field;
      let options = customFields.find((item) => item.fieldName == field);

      if (options && options.cfPossibleValues) {
        let val = {
          ...this.props.dataItem,
          [field]: moment(e.value).format("YYYY-MM-DDTHH:mm:ss"),
          taskCustomField: {
            CustomFieldId: options.id,
            inputType:"Date",
            DateValue: moment(e.value).format("YYYY-MM-DDTHH:mm:ss"),
          },
        };
        this.props.manageCustomValues(val);
      }
    } catch (err) {}
  };
  handleEditCell = () => {
    if(this.props.dataItem.isClosed===false || this.props.dataItem.isClosed==="Open"){

      this.props.onEditCell(
        this.props.dataItem,
        this.props.field,
        this.props.stateData
      );
    }
  };
  render() {
    const { dataItem, field } = this.props;
    const userEmail = secureLocalStorage.getItem("userName");
    const owner = dataItem.owner;
    const dataValue =
      dataItem[field] === null || dataItem[field] == undefined
        ? ""
        : dataItem[field];
    const value = this.props.dataItem[this.props.field];
    const cf =
      this.props.dataItem.customFields &&
      this.props.dataItem.customFields.find(
        (item) => item.fieldName == this.props.field
      );
    let access = false;
    if (cf) {
      access = true;
    }
    if (this.props.field && this.props.field === this.props.dataItem.inEdit) {
      return (
        <td>
          <DatePicker
            format="dd-MMM-yyyy"
            id="datefield"
            defaultValue={value}
            onChange={this.handleChange.bind(this)}
            onBlur={this.handleBlur.bind(this)}

            // weekNumber={true}
            defaultShow={true}
            // min={new Date()}
          />
        </td>
      );
    } else {
      if (userEmail === owner && access) {
        return (
          <td title={dataValue} onClick={this.handleEditCell}>
            <p>{dataValue ? moment(dataValue).format("DD-MMM-YYYY") : ""}</p>
          </td>
        );
      } else {
        return this.props.dataItem.roleName == "Standard User" ||
          this.props.dataItem.roleName == "View Only" ||
          !access ? (
          <td title={dataValue ? moment(dataValue).format("DD-MMM-YYYY") : ""}>
            <p>{dataValue ? moment(dataValue).format("DD-MMM-YYYY") : ""}</p>
          </td>
        ) : (
          <td
            title={dataValue ? moment(dataValue).format("DD-MMM-YYYY") : ""}
            onClick={this.handleEditCell}
          >
            <p>{dataValue ? moment(dataValue).format("DD-MMM-YYYY") : ""}</p>
          </td>
        );
      }
    }
  }
}
